import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeEmergencyContactListService = (
  params: Types.EmployeeEmergencyContactListRequest
) =>
  RestAPIClient.call<Types.EmployeeEmergencyContactListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List.replace("{employeeId}", params.employeeId.toString())}`,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeEmergencyContactCreateService = (
  params: Types.EmployeeEmergencyContactCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeEmergencyContact>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeEmergencyContactUpdateService = (
  params: Types.EmployeeEmergencyContactUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeEmergencyContact>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeEmergencyContactDeleteService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.EmployeeEmergencyContact>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeEmergencyContactDetailService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.EmployeeEmergencyContact>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
